import {useEffect} from 'react';
import EditorJS from "@editorjs/editorjs";
import ImageTool from "@editorjs/image";
import VideoTool from '@weekwood/editorjs-video';
import Underline from "@editorjs/underline";
import List from '@editorjs/list';
import YoutubeEmbed from 'editorjs-youtube-embed'
import Header from "@editorjs/header";
import config from "../config";
import Embed from '@editorjs/embed';
import axios from 'axios';
import {SanitezeHostUrl} from "../helper";
import {RelatedNews} from "./plugins/RelatedNews";
import {CustomHyperlink} from "./plugins/CustomHyperlink";

function sanitizeOutput (data) {
  return {
    ...data,
    blocks: data.blocks.map((block) => {
      if (block.type !== 'paragraph' && block.type !== 'header') {
        return block;
      }

      return {
        ...block,
        data: {
          ...block.data,
          text: block.data.text
            .replace(/&nbsp;/g, ' ')
            .trim(),
        },
      };
    }),
  }
}

export default function PostEditor ({mediaId, post, onChange, children, mediaHost}) {
  useEffect(() => {
      const loadVideo = async (file) => {
        try {
          const requestData = {
            destination_bucket: `kuntur/${SanitezeHostUrl(mediaHost)}`,
            client_id: "c50a4b94-bed3-11ee-8d05-a634553845fc"
          }

          const presignedResponse = await axios.post(`${config.apiUrl}/api/v1/videos/presigned`, requestData, {
            headers: {
              'Content-Type': 'application/json'
            }
          })

          let presignedBody
          if (presignedResponse) {
            presignedBody = presignedResponse.data;
          } else {
            console.error('Error presigning url', response);
          }

          const response = await axios.put(presignedBody.upload_url, file,
            {
              timeout: 600000
            });

          if (response || response.status === 200) {
            console.log('Video enviado exitosamente');
            return presignedBody.download_url;
          } else {
            console.error('Error al enviar el video:', response);
          }
        } catch (error) {
          console.error('Error al enviar el video:', error);
        }
      };

      let data;
      try {
        data = JSON.parse(post.body);
      } catch {
        data = {
          blocks: [
            {
              type: 'paragraph',
              data: {
                text: post.body,
              },
            },
          ],
        };
      }

      let editorTools = {
        link: {
          class: CustomHyperlink,
          config: {
            shortcut: 'CMD+L',
            target: '_blank',
            rel: 'nofollow',
            availableTargets: ['_blank'],
            availableRels: ['nofollow','follow'],
            validate: false,
          }
        },
        embed: {
          class: Embed,
          config: {
            services: {
              twitter: true,
              twitterX: {
                regex: /^https?:\/\/x\.com\/(?:#!\/)?(\w+)\/status(?:es)?\/(\d+?.*)?$/,
                embedUrl: 'https://twitframe.com/show?url=https://twitter.com/<%= remote_id %>',
                html: '<iframe width="600" height="600" style="margin: 0 auto;" frameborder="0" scrolling="no" allowtransparency="true"></iframe>',
                height: 300,
                width: 600,
                id: ids => ids.join('/status/'),
              },
              tiktok: {
                regex: /^https?:\/\/(?:www\.)?tiktok\.com\/@\w+\/video\/(\d+)(?:\?.*)?$/,
                embedUrl: 'https://www.tiktok.com/embed/v2/<%= remote_id %>',
                html: '<iframe width="600" height="800" style="margin: 0 auto;" frameborder="0" scrolling="no" allowtransparency="true"></iframe>',
                height: 800,
                width: 600,
                id: ids => ids.join('/embed/'),
              },
              // facebook: true,
              instagram: true,
            },
          },
        },
        youtubeEmbed: YoutubeEmbed,
        list: {
          class: List,
          inlineToolbar: true,
          config: {
            defaultStyle: 'unordered'
          }
        },
        image: {
          class: ImageTool,
          config: {
            endpoints: {
              byFile: `${config.apiUrl}/api/v1/image/${mediaId}/content`, // File uploader endpoint
            }
          }
        },
        underline: Underline,
        header: Header
      }

      editorTools.relatedNews = {
        class: RelatedNews,
        config: {
          mediaId: mediaId,
        }
      }

      if (mediaId === 'b9bf98a1-a527-4fd8-8d1f-501b231cd94b' || mediaId === '776ebb76-093e-4340-b889-5d5a58711f11') {
        editorTools.video = {
          class: VideoTool,
          config: {
            uploader: {
              uploadByFile (file) {
                return loadVideo(file).then((finalUrl) => {
                  if (finalUrl) {
                    return {
                      success: 1,
                      file: {
                        url: finalUrl,
                      }
                    };
                  }
                  return {
                    success: 0,
                    file: {
                      url: "",
                    }
                  };

                });
              },
            },
            endpoints: {
              byFile: `${config.apiUrl}/api/v1/video/${mediaId}/content`,
            },
            player: {
              controls: true,
              autoplay: false
            }
          }
        }
      }
      const editor = new EditorJS({
        holder: 'editorjs',
        placeholder: 'Contenido principal...',
        tools: editorTools,
        data: data,
        onChange: () => {
          editor.save().then((outputData) => {
            const sanitizedOutput = sanitizeOutput(outputData);
            console.log('Saving...', sanitizedOutput);
            onChange(sanitizedOutput);
          }).catch((error) => {
            console.error('Saving failed: ', error);
          });
        }
      });

      return () => editor.destroy();
    }
    ,
    [post.id, mediaId]
  )
  ;

  return (
    <div>
      <div id="editorjs"></div>
      {children}
    </div>
  );
}
